// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

export enum EntityApiIdBuf {
  FileIdV0 = 0,
  FileIdUserHomeV0 = 4096,
  FileIdUserArchiveV0 = 4097,
  FileIdSharedDriveHomeV0 = 4098,
  FileIdSharedDriveArchiveV0 = 4099,
  FileIdConversationArtifactsFolderV0 = 4100,
  UserIdV0 = 65536,
  UserIdSearchIndexerV0 = 65537,
  UserIdPolyAgentV0 = 65538,
  UserIdClientOnlyV0 = 65539,
  UserIdAnonymousV0 = 65540,
  SharedDriveIdV0 = 131072,
  ConversationIdV0 = 262144,
  SearchIdV0 = 327680
}
